import { buildsServiceApi } from "../../api";

export const addProjectAdmin = async (projectId: string, userId: string) => {
  return buildsServiceApi.post(`/projects/${projectId}/admin`, { userId });
};
